// utils/discount.js
export const isDiscountActive = (item) => {
  if (!item?.discount) return false;

  const today = new Date();
  const discountStart = item?.discountStart
    ? new Date(item.discountStart)
    : null;
  const discountEnd = item?.discountEnd ? new Date(item.discountEnd) : null;

  // Popust je aktivan ako:
  // - discountStart postoji i manji je ili jednak od danas
  // - i discountEnd nije postavljen ili je danas manji ili jednak discountEnd
  return (
    discountStart &&
    discountStart <= today &&
    (!discountEnd || today <= discountEnd)
  );
};
